<template>
  <div>
    <a-card>
      <a-form :form="form" class="custom pick-100 form-input about">
        <a-row>
          <a-col :span="24">
            <a-divider class="color-orange mt-6" orientation="left">供应商信息</a-divider>
          </a-col>

          <table style="width:100%" class="fx-form">
            <tr>
              <th>供应商名称:</th>
              <td>
                <a-form-item>
                  <a-input
                      size="large"
                      style="color: black;font-weight: bold"
                      disabled
                      v-decorator="['supplierName',{initialValue:supplier.supplierName}]"
                  />
                </a-form-item>
              </td>
              <th>
                <span v-if="supplier.supplierType === '2'">统一社会信用代码:</span>
                <span v-else-if="supplier.supplierType === '1' && supplier.natureType === '2'">注册号:</span>
                <span v-else-if="supplier.supplierType === '1' && supplier.natureType === '1'">身份证号:</span>
              </th>
              <td>
                <a-form-item>
                  <a-input
                      v-if="supplier.supplierType === '2'"
                      size="large"
                      style="color: black;font-weight: bold"
                      disabled
                      v-decorator="['supplierCode',{initialValue:supplier.supplierCode}]"
                  />
                  <a-input
                      v-if="supplier.supplierType === '1'"
                      size="large"
                      style="color: black;font-weight: bold"
                      disabled
                      v-decorator="['supplierCode',{initialValue:supplier.legalIdCard}]"
                  />
                </a-form-item>
              </td>
            </tr>

            <tr>
              <th class="not-null">联系人:</th>
              <td>
                <a-form-item>
                  <a-input
                      size="large"
                      v-decorator="['contacts',{initialValue:account.nickname, rules: [{ required: true, message: '联系人不能为空'}]}]"
                  />
                </a-form-item>
              </td>
              <th class="not-null">联系人手机号:</th>
              <td>
                <a-form-item>
                  <a-input
                      size="large"
                      v-decorator="['contactsPhone',{initialValue:account.phone ,rules: [{type: 'string',message: '输入正确的手机号', required: true, pattern: /^[1][3-9][0-9]{9}$/ }]}]"
                  />
                </a-form-item>
              </td>
            </tr>

            <tr>
              <th class="not-null">电子邮件:</th>
              <td>
                <a-form-item>
                  <a-input
                      size="large"
                      v-decorator="['supplierEmail',{initialValue:supplier.email, rules: [{ required: true, message: '邮箱不能为空'},{ type: 'email',message: '邮箱不符合规范'}]}]"
                  />
                </a-form-item>
              </td>

              <th>办公电话:</th>
              <td>
                <a-form-item>
                  <a-input
                      size="large"
                      v-decorator="['mobile',{initialValue:supplier.mobile, rules: [{type: 'string',message: '请输入正确的电话号码', required: false, pattern: /\d{3}-\d{8}|\d{4}-\d{7,8}/ }]}]"
                  />
                </a-form-item>
              </td>

            </tr>

          </table>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-divider class="color-orange mt-6" orientation="left">订单确认</a-divider>
            <p style="text-align: center">*本项目只允许每位供应商报名<span
                style="font-size: 16px;font-weight: bold;color: red">{{ project.cgbzsl }}</span>个包组</p>
          </a-col>
          <a-col :span="24">
            <a-table :columns="columns"
                     :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange,getCheckboxProps: getCheckboxProps,columnWidth:'100',columnTitle:'选择',fixed: false }"
                     :rowKey="record => record.id"
                     :pagination="false"
                     :customRow="setRow"
                     :dataSource="data"
                     bordered
            >
              <template slot="packCode" slot-scope="record">
                {{ record.packCode }}
              </template>
              <template slot="packName" slot-scope="record">
                {{ record.packName }}
              </template>
              <template slot="servicePrice" slot-scope="record">
                <span style="color: red" v-if="record.regFee">￥ {{ record.regFee }} </span>
                <span style="color: red" v-else>无需缴纳</span>
              </template>
              <template slot="signStatus" slot-scope="record">
                <span style="color: red" v-if="record.disabled === true">已报名</span>
                <span style="color: red" v-else>未报名</span>
              </template>
            </a-table>
          </a-col>
        </a-row>
        <a-row class="mt-6">
          <a-col :span="6" :offset="9">
            <a-button align="right" type="primary" size="large" :loading="loading" @click="checkSupplierSign"
                      block>确认报名
            </a-button>
          </a-col>
        </a-row>
      </a-form>
    </a-card>
    <a-divider/>
    <payment-control-modal :projectId="projectId" @finish="paymentControlFinish"></payment-control-modal>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import qs from 'qs'
import {PageView} from '@/layouts'
import STable from '@/components/Table'
import moment from 'moment'
import 'vue-area-linkage/dist/index.css'
import {pca, pcaa} from 'area-data'
import PaymentControlModal from './PaymentControlModal.vue'

export default {
  props: ["projectId"],
  created() {
    this.loadData()
  },
  components: {
    PageView,
    STable,
    moment,
    PaymentControlModal
  },
  name: 'Step1',
  data() {
    return {
      labelCol: {lg: {span: 5}, sm: {span: 5}},
      wrapperCol: {lg: {span: 19}, sm: {span: 19}},
      form: this.$form.createForm(this),
      queryParam: {},
      packs: {},
      supplier: {},
      loading: false,
      data: [],
      project: {},
      initDataValue: {},
      orderId: '',
      selectedRowKeys: [],
      account: '',
      columns: [
        {
          title: '包组编号',
          width: 150,
          scopedSlots: {customRender: 'packCode'}
        },
        {
          title: '包组名称',
          width: 500,
          scopedSlots: {customRender: 'packName'}
        },
        {
          title: '平台服务费',
          width: 150,
          scopedSlots: {customRender: 'servicePrice'}
        },
        {
          title: '报名状态',
          width: 100,
          scopedSlots: {customRender: 'signStatus'}
        }

      ],
      fixed: false
    }
  },
  methods: {
    nextStep() {
      const {form: {validateFields}} = this
      // 先校验，通过表单校验后，才进入下一步
      validateFields((err, values) => {
        if (!err) {
          return
        }
        this.$emit('nextStep')
      })
    },
    loadData() {
      if (!this.projectId) {
        this.error("项目ID数据异常!")
        return;
      }
      let url = '/api/v1/supplier/sign/getProjectDetails.json?projectId=' + this.projectId
      this.$http.get(url).then(res => {
        this.data = res.packList
        for (let i = 0; i < this.data.length; i++) {
          if (this.data[i].disabled === false) {
            var id = this.data[i].id;
            // this.selectedRowKeys.push(id)
          }
        }
        this.supplier = res.supplier
        this.account = res.account
        this.project = res.project
      })
    },
    paymentControlFinish() {
      this.loadData()
    },
    error(val) {
      this.$error({
        title: '提示',
        content: val
      })
    },

    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    getCheckboxProps: record => ({
      props: {
        disabled: record.disabled === true
      },
    }),
    setRow(record) {
      return {
        on: {
          click: () => {
            let rowKeys = this.selectedRowKeys;
            if (rowKeys.length > 0 && rowKeys.includes(record.key)) {
              rowKeys.splice(rowKeys.indexOf(record.key), 1);
            } else {
              rowKeys.push(record.key);
            }
            this.selectedRowKeys = rowKeys;
          }
        }
      };
    },
    async checkSupplierSign(params) {
      this.form.validateFields(async (err, values) => {
        if (err) {
          return
        }
        let that = this
        that.loading = true
        if (this.selectedRowKeys.length === 0) {
          this.error("请勾选包组")
          that.loading = false
          return
        }
        let params = this.form.getFieldsValue()
        params.packsList = []
        let isShow = false
        for (let i = 0; i < this.selectedRowKeys.length; i++) {
          if (this.selectedRowKeys[i]) {
            let findData = this.data.filter(item => item.id === this.selectedRowKeys[i])[0]
            isShow = isShow || !!(findData && findData.regFee)
            params.packsList.push(this.selectedRowKeys[i])
          }
        }
        if (params.packsList.length == 0) {
          this.error("请勾选包组")
          that.loading = false
          return;
        }
        params.supplierAddress = params.supplierAddress
        params.projectId = this.projectId
        const res = await this.$http.post('/api/v1/supplier/sign/checkSupplierSign.json', qs.stringify(params, {allowDots: true}))
        if (res.code == 301) {
          that.$confirm({
            title: "提示",
            content: res.msg,
            okText: '立即认证',
            cancelText: '继续报名',
            onOk() {
              that.$http.get('/api/v1/supplier/getAccountInfo.json').then(res => {
                that.$router.push({path: '/enterprise/LegalCertificationIndex'});
              })
            },
            onCancel() {
              that.showConfirm(params, isShow)
            }
          });
          return
        } else {
          that.showConfirm(params, isShow)
        }
      })
    },
    showConfirm(params, isShow) {
      const that = this
      if (isShow) {
        that.$confirm({
          title: "提示",
          content: '本项目只支持线上报名，一经售后不退；请确认！！',
          onOk() {
            that.onSubmit(params)
          },
          onCancel() {
            that.loading = false
            console.log("用户取消")
          }
        });
      } else {
        that.onSubmit(params)
      }
    },
    // 校验联系人邮箱
    onSubmit(params) {
      const that = this
      that.$http.post('/api/v1/supplier/sign/supplierSign.json', qs.stringify(params)).then(function (res) {
        that.orderId = res.orderId
        that.loading = false
        if (res.code === 200) {
          if (res.orderId === 'OK') {
            that.$emit('finish')
          } else {
            that.$emit('setOrderId', that.orderId)
            that.$emit('nextStep')
          }
          // that.$emit('changeOrderId', that.orderId)
          // that.$router.push({path: '/SignIndex/SignPay?orderId=' + that.orderId})
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.step-form-style-desc {
  padding: 0 56px;
  color: rgba(0, 0, 0, .45);

  h3 {
    margin: 0 0 12px;
    color: rgba(0, 0, 0, .45);
    font-size: 16px;
    line-height: 32px;
  }

  h4 {
    margin: 0 0 4px;
    color: rgba(0, 0, 0, .45);
    font-size: 14px;
    line-height: 22px;
  }

  p {
    margin-top: 0;
    margin-bottom: 12px;
    line-height: 22px;
  }
}

/deep/ .ant-form-item-label label {
  color: #8c8c8c;
}

/deep/ .ant-form-item-children {
  color: #000;
  font-weight: bold;
}

.register-title {
  position: relative;
}

.register-title img {
  margin: auto;
}

.register-title p {
  position: absolute;
  top: 10px;
  font-size: 20px;
  color: #fff;
  width: 100%;
  text-align: center;
}

.ant-input {
  width: 100%;
}

th {
  width: 125px;
}

tr {
  height: 65px;
}

.ant-table-thead > tr > th {
  font-weight: bold;
}
</style>
